import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import chart_download from '../../../../assets/images/chart_download.png';

import { faArrowLeft, faPencil, faEnvelope, faFlag, faEllipsis, faPlus, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row, Table, Dropdown, Form, Tab, Tabs, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Edit from "../../../../assets/images/edit.png";
import Trash from '../../../../assets/images/trash.png';
import Photo from '../../../../assets/images/photo.png';
import System0 from '../../../../assets/images/system.png';
import System1 from '../../../../assets/images/system2.png';
import System2 from '../../../../assets/images/system3.png';
import System3 from '../../../../assets/images/system4.png';
import System4 from '../../../../assets/images/system5.png';

import { RECOVERYNOTESAVE, ULDRECOVERYDETAIL } from '../../../../Utils/conts';
import { withRFSToken } from '../../../../Services/axios.js';
import ImageUpload from '../../../../Components/common/ImageUpload.js';
import { toast } from 'react-toastify';


const RecoveryDetails = () => {
    const [key, setKey] = useState('ULD_Details');
    const systemImages = [System0, System1, System2, System3, System4];

    const isMounted = useRef(false);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [recoveryReport, setRecoveryReport] = useState(null);
    const [attachment, setAttachment] = useState(null);
    const [log, setLog] = useState(null);
    const [isEditing, setIsEditing] = useState(false);
    const [loading, setLoading] = useState(false);
    const [note, setNote] = useState('');
    const [missing_date, setMissingDate] = useState('');

    const u_number = localStorage.getItem('UN');
    const loadDetails = async (mid) => {
        // const misId = mid ? mid : 
        try {
            const res = await withRFSToken.post(ULDRECOVERYDETAIL, { missing_id: u_number })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    setSelectedRowData(innerData.uld_details);
                    setRecoveryReport(innerData.recovery_report);
                    setNote(innerData.recovery_case_note);
                    setAttachment(innerData.attachments);
                    setLog(innerData.recovery_log);
                    setMissingDate(innerData.missing_date);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        loadDetails();
        isMounted.current = true;
    }, []);

    const handleEditClick = async () => {
        if (isEditing) {
            // Set loading state
            try {
                const res = await withRFSToken.post(RECOVERYNOTESAVE, { missing_id: u_number, recovery_case_note: note });
                if (res.data.response_code === 200) {
                    const innerData = res.data.response_data;
                    setNote(innerData);
                    setLoading(false);
                } else {
                    toast.error(res.data.response_msg);
                }
            } catch (error) {
                console.error('Error saving the note:', error);
            }
            //    finally {
            //     setLoading(false); // Reset loading state after API call
            //   }
        }
        // Toggle editing state
        setIsEditing(!isEditing);
    };
    const handleNoteChange = (event) => {
        setNote(event.target.value);
    };

    return (
        <div className="">
            {console.log('formdata', recoveryReport)}
            <Header logo_url='/Recovery' />
            <div className="schedule">
                <LeftMenu />
                <div className='main-panel'>
                    <Link to={'/Recovery'} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                    <div className="mt-3 nestedtabs rounded">
                        <div className='d-flex justify-content-between'>
                            <div className='viewbook'>
                                <h4>{selectedRowData?.uld_information.uld_number}</h4>
                                <p>Reported missing on <b> {missing_date} </b> </p>
                            </div>
                            <div className='d-flex align-items-center'>
                                <div className='me-3'>

                                    {/* <span> <img src={chart_download} /> Download Report</span> */}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=''> {/* maindiv */}
                        <Row>
                            <Col sm='4'>
                                <div className='nestedtabs rounded mt-3 log_height'>
                                    <Tabs
                                        id="controlled-tab-example"
                                        activeKey={key}
                                        onSelect={(k) => setKey(k)}
                                        className="mb-4 reco_tab"
                                    >
                                        <Tab eventKey="ULD_Details" title="ULD Details">
                                            <div className='recovery_info mb-3 bordr_bottom_dash'>
                                                <h4>ULD Information</h4>

                                                <ul>
                                                    <li>
                                                        <span>ULD Number</span> <span>: {selectedRowData?.uld_information.uld_number}</span>
                                                    </li>
                                                    <li>
                                                        <span>Condition</span> <span>:   {selectedRowData?.uld_information.condition}</span>
                                                    </li>
                                                    <li>
                                                        <span>Last Seen Location</span> <span>:  {selectedRowData?.uld_information.last_seen_location}</span>
                                                    </li>
                                                    <li>
                                                        <span>Last Seen Date</span> <span>:  {selectedRowData?.uld_information.last_seen_date}</span>
                                                    </li>
                                                </ul>
                                            </div>

                                            <div className='recovery_info '>
                                                <h4>Movement Information</h4>

                                                <ul>
                                                    <li>
                                                        <span>Last Movement Type</span> <span>:    {selectedRowData?.movement_information?.operation_type}</span>
                                                    </li>
                                                    {['UCM In', 'UCM Out'].includes(selectedRowData?.movement_information?.operation_type) ?
                                                        <>
                                                            <li><span>Truck/Flight </span> <span>: {selectedRowData?.movement_information?.flight_or_truck === 'F' ? 'Flight' : 'Truck'}</span></li>
                                                            <li><span>Flight Number </span> <span>: {selectedRowData?.movement_information?.flight_number}</span></li>
                                                            <li><span>Flight Date </span> <span>: {selectedRowData?.movement_information?.flight_date}</span></li>
                                                            <li><span>Origin </span> <span>: {selectedRowData?.movement_information?.origin}</span></li>
                                                            <li><span>Origin Handler Name</span> <span>: {selectedRowData?.movement_information?.origin_handler}</span></li>
                                                            <li><span>Destination</span> <span>: {selectedRowData?.movement_information?.destination}</span></li>
                                                            <li><span>Destination Handler Name</span> <span>: {selectedRowData?.movement_information?.destination_handler}</span></li>
                                                            <li><span>Registration Number</span> <span>: {selectedRowData?.movement_information?.flight_reg_number}</span></li>
                                                        </>
                                                        : (selectedRowData?.movement_information?.operation_type === 'LUC Out' ?
                                                            <>
                                                                <li><span>Transfer Date</span> <span>: {selectedRowData?.movement_information?.operation_date}</span></li>
                                                                <li><span>Control Receipt Number</span> <span>: {selectedRowData?.movement_information?.control_receipt_no}</span></li>
                                                                <li><span>Transfer Point</span> <span>: {selectedRowData?.movement_information?.transfer_point}</span></li>
                                                                <li><span>Transferred By</span> <span>: {selectedRowData?.movement_information?.transferred_by}</span></li>
                                                                <li><span>Final Destination</span> <span>: {selectedRowData?.movement_information?.luc_final_dest}</span></li>
                                                                <li><span>Received By</span> <span>: {selectedRowData?.movement_information?.received_by}</span></li>
                                                            </>
                                                            : (selectedRowData?.movement_information?.operation_type === 'LUC In' ?
                                                                <>
                                                                    <li><span>Return Date</span> <span>: {selectedRowData?.movement_information?.operation_date}</span></li>
                                                                    <li><span>Control Receipt Number</span> <span>: {selectedRowData?.movement_information?.control_receipt_no}</span></li>
                                                                    <li><span>Return To</span> <span>: {selectedRowData?.movement_information?.return_to}</span></li>
                                                                    <li><span>Transfer Point</span> <span>: {selectedRowData?.movement_information?.transfer_point}</span></li>
                                                                    <li><span>Returned By</span> <span>: {selectedRowData?.movement_information?.returned_by}</span></li>
                                                                </>
                                                                : (['Station Transfer', 'Transfer Request'].includes(selectedRowData?.movement_information?.operation_type) ?
                                                                    <>
                                                                        <li><span>Transfer Date</span> <span>: {selectedRowData?.movement_information?.operation_date}</span></li>
                                                                        <li><span>Control Receipt Number</span> <span>: {selectedRowData?.movement_information?.control_receipt_no}</span></li>
                                                                        <li><span>Transfer Point</span> <span>: {selectedRowData?.movement_information?.transfer_point}</span></li>
                                                                        <li><span>Transferred By</span> <span>: {selectedRowData?.movement_information?.transferred_by}</span></li>
                                                                        <li><span>Final Destination</span> <span>: {selectedRowData?.movement_information?.luc_final_dest}</span></li>
                                                                        <li><span>Received By</span> <span>: {selectedRowData?.movement_information?.received_by}</span></li>
                                                                    </>
                                                                    : (['Repair In', 'Repair Out'].includes(selectedRowData?.movement_information?.operation_type) ?
                                                                        <>
                                                                            <li><span>Repair Name</span> <span>: {selectedRowData?.movement_information?.repair_name}</span></li>
                                                                            <li><span>Repair Station</span> <span>: {selectedRowData?.movement_information?.repair_station}</span></li>
                                                                            <li><span>Repair In</span> <span>: {selectedRowData?.movement_information?.operation_date}</span></li>
                                                                        </>
                                                                        : (selectedRowData?.movement_information?.operation_type === 'Lease Out' ?
                                                                            <>
                                                                                <li><span>Station Out</span> <span>: {selectedRowData?.movement_information?.destination}</span></li>
                                                                            </>
                                                                            : (selectedRowData?.movement_information?.operation_type === 'SCM' ?
                                                                                <>
                                                                                    <li><span>Date of Check</span> <span>: {selectedRowData?.movement_information?.operation_date}</span></li>
                                                                                    <li><span>Destination</span> <span>: {selectedRowData?.movement_information?.destination}</span></li>
                                                                                    <li><span>Destination Handler Name</span> <span>: {selectedRowData?.movement_information?.destination_handler}</span></li>
                                                                                </>
                                                                                : ''
                                                                            )
                                                                        )
                                                                    )
                                                                )
                                                            )
                                                        )
                                                    }
                                                    {/* <li>
                                                        <span>Flight Number</span> <span>:   fsfsdfvhvbhjdsa</span>
                                                    </li>
                                                    <li>
                                                        <span>Flight Date</span> <span>:   sdsghsahgdhg</span>
                                                    </li>
                                                    <li>
                                                        <span>Origin</span> <span>:  demo test</span>
                                                    </li>
                                                    <li>
                                                        <span>Origin Handler Name</span> <span>: demo test</span>
                                                    </li>
                                                    <li>
                                                        <span>Destination</span> <span>: demo text</span>
                                                    </li>
                                                    <li>
                                                        <span>Destination Handler Name</span> <span>:  demo text</span>
                                                    </li>
                                                    <li>
                                                        <span>Registration Number</span> <span>:  demo text</span>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        </Tab>
                                        <Tab eventKey="Recovery_Report" title="Recovery Report">
                                            <div className='recovery_info mb-4'>
                                                <h4>Recovery Information</h4>
                                                <ul>
                                                    <li>
                                                        <span>Recovery Status</span>
                                                        <span>: {recoveryReport?.recovery_status}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className='recovery_info mb-3 bordr_bottom_dash'>
                                                <h4>Contact Information</h4>
                                                <ul>
                                                    <li>
                                                        <span>Name</span> <span>: {recoveryReport?.contact_person_name}</span>
                                                    </li>
                                                    <li>
                                                        <span>Department</span> <span>: {recoveryReport?.contact_person_department}</span>
                                                    </li>
                                                    <li>
                                                        <span>Email Address</span> <span>: {recoveryReport?.contact_person_email}</span>
                                                    </li>
                                                    <li>
                                                        <span>Teliphone Number</span> <span>:  {recoveryReport?.contact_person_number}</span>
                                                    </li>
                                                    <li>
                                                        <span>Origin Handler Name</span> <span>: {recoveryReport?.contact_person_name}</span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div className='recovery_info'>
                                                <h4>Extra Information</h4>
                                                <Form.Group className="mb-1" >
                                                    <Form.Control as="textarea" name='extra_information' readonly='readonly' style={{ height: '120px' }} />
                                                </Form.Group>
                                            </div>
                                        </Tab>
                                    </Tabs>
                                </div>
                            </Col>
                            <Col sm='4'>
                                <div className='nestedtabs rounded mt-3'>
                                    <div className='recovery_info'>
                                        <div className='d-flex justify-content-between align-items-center mb-2'>
                                            <h4 className='mb-0'>Recovery Case - Notes</h4>
                                            <div className='edit_note' onClick={handleEditClick}>
                                                <FontAwesomeIcon icon={isEditing ? (loading ? '' : faSave) : faPencil} /> <span>{isEditing ? (loading ? 'Saving...' : 'Save') : 'Edit'}</span>
                                            </div>
                                        </div>
                                        <Form.Group>
                                            <Form.Control
                                                as="textarea"
                                                name='recovery_note'
                                                style={{ height: '185px' }}
                                                disabled={!isEditing}
                                                value={note}
                                                onChange={handleNoteChange}
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                                <div className='nestedtabs rounded mt-3 case_height'>
                                    <div className='recovery_info'>
                                        <ImageUpload
                                            attachable_type={"missing_uld"}
                                            attachable_id={selectedRowData?.missing_id}
                                            attachments={attachment}
                                            onDeleteSuccess={() => loadDetails(selectedRowData?.missing_id)}
                                            attachment_no={selectedRowData?.uld_information.uld_number}
                                        />
                                        {/* <div className="d-flex justify-content-between align-items-center">
                                            <h4>Recovery Case - Attachments</h4>
                                            <div className="d-flex rightdrop">
                                                <Dropdown>
                                                    <Dropdown.Toggle variant="link" id="dropdown-basic">
                                                        <FontAwesomeIcon icon={faEllipsis} />
                                                    </Dropdown.Toggle>

                                                    <Dropdown.Menu>
                                                        <Dropdown.Item href="#">
                                                            Open gallery view
                                                        </Dropdown.Item>{" "}
                                                        <Dropdown.Item href="#">Download all</Dropdown.Item>
                                                    </Dropdown.Menu>
                                                </Dropdown>
                                                <div  >
                                                    <button className="raplas" >
                                                        <FontAwesomeIcon icon={faPlus} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div> */}
                                        {/* <Table className='recovery_table '>
                                            <thead>
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Size</th>
                                                    <th>Date Added</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><img src={Photo} style={{ width: '25px' }} /> upload.png</td>
                                                    <td>14 KB</td>
                                                    <td>10 Jul 2024 2:12pm</td>
                                                    <td><Link><img src={Edit} /></Link><Link><img src={Trash} /></Link></td>
                                                </tr>
                                                <tr>
                                                    <td><img src={Photo} style={{ width: '25px' }} /> upload.png</td>
                                                    <td>14 KB</td>
                                                    <td>10 Jul 2024 2:12pm</td>
                                                    <td><Link><img src={Edit} /></Link><Link><img src={Trash} /></Link></td>
                                                </tr>
                                                <tr>
                                                    <td><img src={Photo} style={{ width: '25px' }} /> upload.png</td>
                                                    <td>14 KB</td>
                                                    <td>10 Jul 2024 2:12pm</td>
                                                    <td><Link><img src={Edit} /></Link><Link><img src={Trash} /></Link></td>
                                                </tr>
                                            </tbody>
                                        </Table> */}
                                    </div>
                                </div>
                            </Col>
                            <Col sm='4'>
                                <div className='nestedtabs rounded mt-3 log_height'>
                                    <div className='recovery_info'>
                                        <h4>Recovery Log</h4>

                                        {log?.map((details, index) => (
                                            <Stack direction="horizontal" key={index} gap={3} className='p-4'>
                                                <div className='log_img'>
                                                    <img src={systemImages[details.id % systemImages.length]} />
                                                </div>
                                                <div className='sysm_text'>
                                                    <h3>{details.status_message}</h3>
                                                    <span>{details.date} , {details.time}</span>
                                                </div>
                                            </Stack>
                                        ))}
                                        {/* <Stack direction="horizontal" gap={3} className='p-4'>
                                            <div className='log_img'>
                                                <img src={System5} />
                                            </div>
                                            <div className='sysm_text'>
                                                <h3>ULD Recovered by CEVA</h3>
                                                <span>3 sep 2024 , 8:00 PM</span>
                                            </div>
                                        </Stack>

                                        <Stack direction="horizontal" gap={3} className='p-4'>
                                            <div className='log_img'>
                                                <img src={System4} />
                                            </div>
                                            <div className='sysm_text'>
                                                <h3>Response Received from CEVA</h3>
                                                <span>3 sep 2024 , 03:20 PM</span>
                                            </div>
                                        </Stack>
                                        <Stack direction="horizontal" gap={3} className='p-4'>
                                            <div className='log_img'>
                                                <img src={System3} />
                                            </div>
                                            <div className='sysm_text'>
                                                <h3>Missing report shared with CEVA</h3>
                                                <span>3 sep 2024 , 03:20 PM</span>
                                            </div>
                                        </Stack>
                                        <Stack direction="horizontal" gap={3} className='p-4'>
                                            <div className='log_img'>
                                                <img src={System2} />
                                            </div>
                                            <div className='sysm_text'>
                                                <h3>ULD reported missing by user 123</h3>
                                                <span>3 sep 2024 , 03:20 PM</span>
                                            </div>
                                        </Stack>
                                        <Stack direction="horizontal" gap={3} className='p-4'>
                                            <div className='log_img last'>
                                                <img src={System} />
                                            </div>
                                            <div className='sysm_text'>
                                                <h3>ULD detected missing by system</h3>
                                                <span>3 sep 2024 , 03:20 PM</span>
                                            </div>
                                        </Stack> */}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default RecoveryDetails;